
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';

const rowStyleCompta = (record, index, defaultStyle = {}) => {
    if (record && record.montant > 0 )
        return {
            ...defaultStyle,
            borderLeftColor: red[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };
  

        if (record && record.montant< 0)
        return {
            ...defaultStyle,
            borderLeftColor: green[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };

        if (record && record.montant=== 0)
        return {
            ...defaultStyle,
            borderLeftColor: grey[550],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };
        


     
    return defaultStyle;

};

export default rowStyleCompta;